import REDIRECTS from '~/constants/redirects'
import { navigateTo } from '#app'
import {
  getDynamicRoute,
  getMarketRedirect,
  isMarketPath,
} from '~/src/utils/redirects'

export default defineNuxtRouteMiddleware((to) => {
  const path = to.path.replace(/\/$/, '')
  const redirectTo = REDIRECTS[path] || getDynamicRoute(path)
  const isExternal = redirectTo && redirectTo.startsWith('https')
  const query = to.query

  if (query && query.tab && isMarketPath(path)) {
    return navigateTo(getMarketRedirect(path, query.tab), { redirectCode: 301 })
  }

  if (!redirectTo) return

  if (isExternal) return navigateTo(redirectTo, { external: true })

  return navigateTo(redirectTo, { redirectCode: 301 })
})
